import React, { FC } from 'react'

import { IconDocumentPptProps } from './IconDocumentPpt.types'
import * as Styled from './styles/IconDocumentPpt.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDocumentPpt: FC<IconDocumentPptProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDocumentPptProps['size'],
  isResponsive = false,
}: IconDocumentPptProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#ef47caab-93cc-41d2-8aad-d7a40f643d2a__a)' strokeLinecap='round' strokeWidth='2'>
          <path d='M11.467 12.892h7.53V5.89' stroke='#0D0D0D' strokeLinejoin='round' />
          <path
            d='M20.707 4.95a4.265 4.265 0 0 0-2.774 1.027l-5.408 4.64a4.249 4.249 0 0 0-1.485 3.233v24.93c0 2.2 1.8 4 3.48 4h18.44c2.72 0 4-1.8 4-4V4.95H20.707Z'
            stroke='#0D0D0D'
            strokeMiterlimit='10'
          />
          <path
            d='M30.172 28.933v-5.858m-7.809 5.857v-5.857h1.71s1.707-.123 1.707 1.707-1.707 1.718-1.707 1.718h-1.71m-6.713 2.432v-5.857h1.71s1.707-.123 1.707 1.707S17.36 26.5 17.36 26.5h-1.71m12.57-3.425h3.907'
            stroke='#E60000'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='ef47caab-93cc-41d2-8aad-d7a40f643d2a__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconDocumentPpt
